import { Dropdown } from "react-bootstrap";
import { useTheme } from "../../../context/ThemeContext";

const ThemeDropdown = () => {
  const { setTheme } = useTheme();

  const themeHandler = (theme: string) => {
    const validThemes = ["dark", "light", "preset-1"];

    if (!validThemes.includes(theme)) {
      console.error('Invalid theme. Use "dark", "light", or "preset-1".');
      return;
    }
    const bodyElement = document.body;
    setTheme(theme as any);
    bodyElement.setAttribute("data-pc-sidebar-theme", theme);
    bodyElement.setAttribute("data-pc-theme", theme);
  };
  return (
    <Dropdown as="li" className="pc-h-item d-md-inline-flex">
      <Dropdown.Toggle
        as="a"
        className="pc-head-link arrow-none me-0"
        data-bs-toggle="dropdown"
        href="#"
        role="button"
        aria-haspopup="false"
        aria-expanded="false"
      >
        <i className="ph-duotone ph-sun-dim"></i>
      </Dropdown.Toggle>
      <Dropdown.Menu className="dropdown-menu-end pc-h-dropdown">
        <Dropdown.Item onClick={() => themeHandler("dark")}>
          <i className="ph-duotone ph-moon"></i>
          <span>Dark</span>
        </Dropdown.Item>
        <Dropdown.Item onClick={() => themeHandler("light")}>
          <i className="ph-duotone ph-sun-dim"></i>
          <span>Light</span>
        </Dropdown.Item>
        <Dropdown.Item onClick={() => themeHandler("preset-1")}>
          <i className="ph-duotone ph-cpu"></i>
          <span>Default</span>
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default ThemeDropdown;
